// extracted by mini-css-extract-plugin
export default {"dummy":"P+bYdLb2JoNbh6HXM+etoQ=="};